module.exports = __webpack_public_path__ + "static/media/Wingsuit Flying.250ed746.jpg";